<template>
    <div>
        <breadcrumbs :text="personLabel" />
        <client-form :person-data="client" :is-member="true" />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {CompanyClientPage} from '~/pages/account/CompanyClientPage.vue'

    // TODO [P1] Need check setup inheritance
    @Component({})
    export class MemberPage extends CompanyClientPage {
        get personLabel() {
            if (this.client.personId) {
                const {prefix, firstName, lastName} = this.client
                return `${prefix || ''} ${firstName || ''} ${lastName || ''}`
            }
            return this.$t('new_member_profile')
        }
    }

    export default MemberPage
</script>
